module.exports = __webpack_public_path__ + "img/96785D_B8A398_63452C_6C5435-256px.873698bb.png";